import { render, staticRenderFns } from "./editMultiCard.vue?vue&type=template&id=47965604&scoped=true"
import script from "./editMultiCard.vue?vue&type=script&lang=js"
export * from "./editMultiCard.vue?vue&type=script&lang=js"
import style0 from "./editMultiCard.vue?vue&type=style&index=0&id=47965604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47965604",
  null
  
)

export default component.exports